import * as THREE from 'three';
import { IVideoTextureEngine } from './IVideoTextureEngine';

export class SyncVideoEngine implements IVideoTextureEngine {
  public texture: THREE.Texture;
  private video: HTMLVideoElement;
  private rVFCId: number | null = null;
  private isDestroyed = false;

  constructor(video: HTMLVideoElement) {
    this.video = video;

    // Create a standard Texture (not VideoTexture) to manually control updates
    this.texture = new THREE.Texture(this.video);
    this.texture.colorSpace = THREE.SRGBColorSpace;
    this.texture.minFilter = THREE.LinearFilter;
    this.texture.magFilter = THREE.LinearFilter;
    // Important: Generate mipmaps is false for video textures usually to save perf
    this.texture.generateMipmaps = false; 
  }

  start(): void {
    console.log('[SyncVideoEngine] Started - using requestVideoFrameCallback');
    this.scheduleNextFrame();
  }

  update(): void {
    // No-op: update loop is driven by requestVideoFrameCallback
  }

  private scheduleNextFrame() {
    if (this.isDestroyed) return;

    if ('requestVideoFrameCallback' in this.video) {
      this.rVFCId = (this.video as any).requestVideoFrameCallback(this.onVideoFrame);
    } else {
      console.warn('[SyncVideoEngine] requestVideoFrameCallback not supported! Falling back to Native.');
      // Fallback behavior if for some reason this engine was selected wrongly
      this.texture.needsUpdate = true;
    }
  }

  private onVideoFrame = (now: number, metadata: VideoFrameCallbackMetadata) => {
    if (this.isDestroyed) return;

    // Manually signal that the texture needs to pick up the new frame
    // Since texture.image references the video element, this tells WebGL to re-upload the current frame
    this.texture.needsUpdate = true;

    // Log first success for debugging
    if (metadata.mediaTime > 0 && metadata.mediaTime < 0.1) {
       // console.log('[SyncVideoEngine] Frame sync active', metadata);
    }

    // Loop
    this.scheduleNextFrame();
  };

  destroy(): void {
    this.isDestroyed = true;
    if (this.rVFCId !== null && 'cancelVideoFrameCallback' in this.video) {
      (this.video as any).cancelVideoFrameCallback(this.rVFCId);
    }
    this.texture.dispose();
  }
}
